$(document).ready(function () {
    $('.currency-mask').mask('#,##0.00', {reverse: true});
    $('.percent-mask').mask('990.9999%', {reverse: true});
    // $('.com-percent-mask').mask('990.9999%', {reverse: true});
    $('.channel-mask').mask('990.9');
    /**
     * on channel mask input blur, format input value
     */
    $('.channel-mask').on('blur', function (event) {
        var val = event.target.value;
        if (val.indexOf('.') == -1) {
            if (val.length > 0) {
                val = val + ".0";
            }
        }
        else {
            var valArr = val.split('.');
            if (valArr[1].length === 0) {
                val = val + "0";
            }
        }
        event.target.value = val;
    });
    //$('.frequency-mask').mask('0000.0', {reverse: true});
    $('.integer-mask').mask('9900000000000', {reverse: false});

   // this.value = this.value.replace(/[^0-9]/g, '');
});
